import React from 'react';
import { CARD_W, ImageCardBody } from './ImageCardGlyph';

/**
 * Static SVG stand-in for the live "Image Cards" (ImageCarousel) block, shown on
 * its palette card in the v2 editor: a section heading above three rounded cards
 * (see {@link ImageCardBody}), each with a title, an image area and a few prose
 * lines. Scales cleanly with its container via the viewBox.
 */

const GAP = 30;
const ROW_X = 30;
const CARD_Y = 72;

const CARDS = [
  { x: ROW_X, title: 'Property details' },
  { x: ROW_X + CARD_W + GAP, title: 'Proposed development' },
  { x: ROW_X + (CARD_W + GAP) * 2, title: 'Valuation summary' },
];

export default function ImageCardPreviewGraphic() {
  return (
    <svg
      viewBox="0 0 1180 436"
      width="100%"
      role="img"
      aria-label="Image Cards block: a heading above three cards, each with an image, title and text"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <text
        x={ROW_X}
        y="34"
        fontFamily="Manrope, system-ui, -apple-system, sans-serif"
        fontSize="30"
        fontWeight="700"
        fill="#20423A"
      >
        Section heading
      </text>
      {CARDS.map((card, index) => (
        <ImageCardBody
          key={card.x}
          clipId={`img-card-clip-${index}`}
          title={card.title}
          x={card.x}
          y={CARD_Y}
        />
      ))}
    </svg>
  );
}
